/**
 * Copyright (c) 2019 Vendor Badge, LLC All Rights Reserved.
 * Created Date: Sunday, 7th April 2019
 *
 * Snackbar Notifications
 * Note: Designed to use in <App>, but can be put anywhere.
 */
import React from 'react';
import { compose } from 'recompose';
import { withSnackbar } from 'notistack';
import { inject, observer } from 'mobx-react';
import { autorun } from 'mobx';

class snackbarNotifier extends React.Component {
  displayed = [];

  storeDisplayed = (id) => {
    this.displayed = [...this.displayed, id];
  };

  componentDidMount() {
    autorun(() => {

      // Store Props
      const { snackbars, removeSnackbar } = this.props.portalStore.snackbar;

      snackbars.forEach((snackbar) => {

        // Do nothing if snackbar is already displayed
        if (this.displayed.includes(snackbar.key)) return;

        // Display snackbar using notistack
        this.props.enqueueSnackbar(snackbar.message, snackbar.options);

        // Keep track of snackbars that we've displayed
        this.storeDisplayed(snackbar.key);

        // Dispatch action to remove snackbar from mobx store
        removeSnackbar(snackbar.key);
      });
    });
  }

  render() {

    return null;
  }
}

const SnackbarNotifier = compose(
  inject('portalStore'),
  observer,
  withSnackbar
)(snackbarNotifier);
export default SnackbarNotifier;
